var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('span',[_c('router-link',{attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.user.NAAM))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }